import firebase from "firebase/app";
import "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyApvA9TRO03XMFry_fnAxSna-0-6Eym8jA",
  authDomain: "work-dc722.firebaseapp.com",
  databaseURL: "https://work-dc722.firebaseio.com",
  projectId: "work-dc722",
  storageBucket: "work-dc722.appspot.com",
  messagingSenderId: "853194066047",
  appId: "1:853194066047:web:c54720d31ba9a03475d74a",
  measurementId: "G-H51EYS6H2Q",
};

firebase.initializeApp(firebaseConfig);

const storage = firebase.storage();

export { storage, firebase as default };
